import { SvgIcon } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import React, { FC } from 'react';

export const LockIcon: FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 24 24'} sx={{ width: '24px', height: '24px' }} {...props}>
    <path
      d={
        'M17.25 8.33333H16.375V6.52381C16.375 4.02667 14.415 2 12 2C9.585 2 7.625 4.02667 7.625 6.52381V8.33333H6.75C5.7875 8.33333 5 9.14762 5 10.1429V19.1905C5 20.1857 5.7875 21 6.75 21H17.25C18.2125 21 19 20.1857 19 19.1905V10.1429C19 9.14762 18.2125 8.33333 17.25 8.33333ZM12 16.4762C11.0375 16.4762 10.25 15.6619 10.25 14.6667C10.25 13.6714 11.0375 12.8571 12 12.8571C12.9625 12.8571 13.75 13.6714 13.75 14.6667C13.75 15.6619 12.9625 16.4762 12 16.4762ZM9.375 8.33333V6.52381C9.375 5.0219 10.5475 3.80952 12 3.80952C13.4525 3.80952 14.625 5.0219 14.625 6.52381V8.33333H9.375Z'
      }
    />
  </SvgIcon>
);
